import React from "react";
import { Mail, MessageSquare, Clock } from "lucide-react";

const KIND = {
  add_service: { label: "Add service", cls: "bg-[#2D6A4F]/15 text-[#2D6A4F]" },
  reactivate: { label: "Reactivate Pro", cls: "bg-[#E9C46A]/30 text-[#8A5A00]" },
};

const daysAgo = (iso) => Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));

export const canInvite = (c) => c.channels.length > 0 && !c.last_invited_at;

export const RecruitCandidates = ({ collectors, selected, onToggle }) => {
  if (!collectors.length) {
    return <p className="text-sm text-[#8A9A86]" data-testid="recruit-no-collectors">No registered collectors near this ZIP to invite. Paste outside contacts below.</p>;
  }
  return (
    <div className="max-h-56 overflow-auto rounded-xl border border-[#1E3F33]/10 divide-y divide-[#1E3F33]/8" data-testid="recruit-collector-list">
      {collectors.map((c) => {
        const ok = canInvite(c);
        return (
          <label key={c.id} className={`flex items-start gap-3 px-3 py-2.5 ${ok ? "cursor-pointer hover:bg-[#F0EFEA]/60" : "opacity-60"}`} data-testid={`recruit-collector-${c.id}`}>
            <input type="checkbox" className="mt-1 rounded border-[#1E3F33]/30 text-[#2D6A4F]" disabled={!ok} checked={ok && selected.includes(c.id)} onChange={() => onToggle(c.id)} data-testid={`recruit-collector-check-${c.id}`} />
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-1.5">
                <span className="text-sm font-medium text-[#1E3F33] truncate">{c.business_name}</span>
                <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${KIND[c.kind].cls}`}>{KIND[c.kind].label}{c.kind === "reactivate" && !c.offers_service ? " + add service" : ""}</span>
                {c.company && <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-[#1E3F33]/8 text-[#5C6B64]">Company</span>}
              </div>
              <div className="flex flex-wrap items-center gap-3 mt-1 text-[11px] text-[#8A9A86]">
                {c.channels.includes("email") && <span className="inline-flex items-center gap-1"><Mail className="w-3 h-3" /> Email</span>}
                {c.channels.includes("sms") && <span className="inline-flex items-center gap-1"><MessageSquare className="w-3 h-3" /> SMS</span>}
                {!c.channels.length && <span>No opted-in contact</span>}
                {c.last_invited_at && <span className="inline-flex items-center gap-1 text-[#CC5A3A]"><Clock className="w-3 h-3" /> Invited {daysAgo(c.last_invited_at)}d ago</span>}
              </div>
            </div>
          </label>
        );
      })}
    </div>
  );
};
